import * as React from 'react';
import { type VariantProps, cva } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground',
        secondary: 'border-transparent bg-secondary text-secondary-foreground',
        outline: 'border-border text-foreground',
        // Semantic stock/expiry states — named for what they mean.
        ok: 'border-transparent bg-status-ok/15 text-status-ok',
        low: 'border-transparent bg-status-low/15 text-status-low',
        out: 'border-transparent bg-status-out/15 text-status-out',
        expiring: 'border-transparent bg-status-expiring/15 text-status-expiring',
        expired: 'border-transparent bg-status-expired/15 text-status-expired',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}
